/**
 * NÚMEROS COMO EN XACTIMATE: la coma separa miles y el punto decimales (Juan-Jared 2026-10-20: "in Xactimate the
 * comma is used for thousands and the dot for decimals; in the CRM is inverted in the quantity and the unit price
 * column"). Un `<input type="number">` deja que el navegador en español pinte "1.234,5" y rechace el punto; por eso
 * las celdas de cantidad y precio son texto con `inputMode="decimal"` y pasan por acá.
 *  - `parsearNumero`: acepta lo que la gente escribe. Con punto y coma, la coma es de miles ("1,234.5"). Solo coma:
 *    es decimal ("2,5" → 2.5) salvo que vaya seguida de exactamente tres dígitos ("1,500" → 1500, miles al estilo
 *    Xactimate). Espacios y "$" se ignoran. Vacío o basura → null.
 *  - `textoDeNumero`: lo que se muestra en la celda: punto decimal, sin agrupar miles (en una celda editable los
 *    miles agrupados estorban al escribir), hasta 4 decimales.
 */
export function parsearNumero(texto: string): number | null {
  let s = texto.trim().replace(/[$\s]/g, '');
  if (!s) return null;
  if (s.includes('.') && s.includes(',')) s = s.replace(/,/g, '');
  else if (s.includes(',')) {
    const partes = s.split(',');
    if (partes.length === 2 && /^\d{3}$/.test(partes[1]!)) s = partes.join('');
    else if (partes.length === 2) s = `${partes[0]}.${partes[1]}`;
    else s = partes.join('');
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}

export function textoDeNumero(n: number | null | undefined, maxDecimales = 4): string {
  if (n == null || !Number.isFinite(n)) return '';
  const f = 10 ** maxDecimales;
  return String(Math.round(n * f) / f);
}
